import Image from 'next/future/image';
import cn from 'classnames';
import premiumBg from '@/public/icons/product/premium_bg.svg';
import premiumKing from '@/public/icons/product/premium_king.svg';
import premiumShiny from '@/public/icons/product/premium_shiny.svg';

const PremiumFeature = ({
  title,
  iconSrc,
}: {
  title: string;
  iconSrc: string;
}) => (
  // eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
  <div className="-ml-[7px] flex items-center justify-start">
    <div className="w-[28px]">
      <Image
        src={iconSrc}
        alt={title}
        width={25}
        height={20}
        className="h-full w-full object-contain"
        priority={true}
      />
    </div>
    <span className="ml-[3px] text-[11px] sm:ml-1 sm:text-xs">{title}</span>
  </div>
);

const PremiumCondition = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'relative rounded border-2 border-black text-white',
      className,
    )}
    // eslint-disable-next-line react/forbid-dom-props
    style={{
      background: 'linear-gradient(92.65deg, #222122 38.4%, #13505B 97.23%)',
    }}
  >
    <div className="relative overflow-hidden px-4 py-3 xxs:px-6 xxs:py-4 sm:px-6 sm:py-4">
      <div className="absolute -bottom-1 right-[-5px] h-[40%] xs:h-[50%] sm:h-[70%] xl:h-[90%]">
        <Image
          src={premiumBg}
          alt="Premium Condition"
          priority={true}
          className="h-full w-full object-contain"
        />
      </div>
      <div className="w-[95%] xs:w-[70%] sm:w-3/5">
        <h3 className="text-sm font-bold sm:text-base">
          Premium Refurbished. Long-Lasting.
        </h3>
        <div className="[&>:not(:last-child)]:mb-[2px] [&>:not(:last-child)]:sm:mb-[4px] mt-2 sm:mt-3">
          <PremiumFeature
            title="Top 5% of our product range"
            iconSrc={premiumKing}
          />
          <PremiumFeature
            title="Looks & works like new"
            iconSrc={premiumShiny}
          />
        </div>
      </div>
    </div>
  </div>
);

export default PremiumCondition;
